/* Interface for App Features */
import { z } from 'zod';

// Personal Tabs
export const IAppDetailsPersonalTabsSchema = z.object({
  objectId: z.string().nullable().optional(),
  entityId: z.string().nullable().optional(),
  name: z.string().nullable().optional(),
  contentUrl: z.string().nullable().optional(),
  websiteUrl: z.string().nullable().optional(),
  scopes: z.array(z.string()).nullable().optional(),
  context: z.array(z.string()).nullable().optional(),
  order: z.number().nullable().optional(),
  displayInNonGeneralChannel: z.boolean().nullable().optional(),
  containerAppIds: z.array(z.string()).nullable().optional(),
  searchUrl: z.string().url().nullable().optional(),
  contentBotId: z.string().nullable().optional(),
  supportedPlatform: z.array(z.string()).nullable().optional()
});


// Bots
export const IAppDetailsBotsSchema = z.object({
  objectId: z.string().nullable().optional(),
  botId: z.string().nullable().optional(),
  needsChannelSelector: z.boolean().nullable().optional(),
  isNotificationOnly: z.boolean().nullable().optional(),
  supportsFiles: z.boolean().nullable().optional(),
  supportsCalling: z.boolean().nullable().optional(),
  supportsVideo: z.boolean().nullable().optional(),
  scopes: z.array(z.string()).nullable().optional(),
  teamCommands: z
    .array(
      z.object({
        title: z.string().nullable().optional(),
        description: z.string().nullable().optional(),
      })
    )
    .nullable()
    .optional(),
  personalCommands: z
    .array(
      z.object({
        title: z.string().nullable().optional(),
        description: z.string().nullable().optional(),
      })
    )
    .nullable()
    .optional(),
  groupChatCommands: z
    .array(
      z.object({
        title: z.string().nullable().optional(),
        description: z.string().nullable().optional(),
      })
    )
    .nullable()
    .optional(),
  requirementSet: z.string().nullable().optional(),
});


// Configurable Tabs
export const IAppDetailsConfigurableTabsSchema = z.object({
  objectId: z.string().nullable().optional(),
  configurationUrl: z.string().nullable().optional(),
  canUpdateConfiguration: z.boolean().nullable().optional(),
  scopes: z.array(z.string()).nullable().optional(),
  context: z.array(z.string()).nullable().optional(),
  sharePointPreviewImage: z.string().nullable().optional(),
  supportedSharePointHosts: z.array(z.string()).nullable().optional(),
});


// Meeting Extensions
const IAppDetailsMeetingExtensionSceneSchema = z.object({
  file: z.string().nullable().optional(),
  id: z.string().nullable().optional(),
  maxAudience: z.number().nullable().optional(),
  name: z.string().nullable().optional(),
  preview: z.string().nullable().optional(),
  seatsReservedForOrganizersOrPresenters: z.number().nullable().optional(),
});

export const IAppDetailsMeetingExtensionsSchema = z.object({
  scenes: z.array(IAppDetailsMeetingExtensionSceneSchema).nullable().optional(),
  supportsStreaming: z.boolean().nullable().optional(),
  isAnonymousAccessAllowed: z.boolean().nullable().optional(),
});

// Activity Feed
export const IAppDetailsActivityFeedSchema = z.object({
  activityTypes: z.array(
    z.object({
      type: z.string().nullable().optional(),
      description: z.string().nullable().optional(),
      templateText: z.string().nullable().optional(),
    })
  ).nullable().optional(),
});


// Messaging Extensions

// Messaging Extensions
const IAppDetailsMessagingExtensionCommandParameterSchema = z.object({
  name: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  inputType: z.string().nullable().optional(),
  value: z.string().nullable().optional(),
  choices: z.array(z.string()).nullable().optional(),
});

const IAppDetailsMessagingExtensionCommandSchema = z.object({
  id: z.string().nullable().optional(),
  type: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  initialRun: z.boolean().nullable().optional(),
  fetchTask: z.boolean().nullable().optional(),
  context: z.array(z.string()).nullable().optional(),
  apiResponseRenderingTemplateFilePath: z.string().nullable().optional(),
  parameters: z
    .array(IAppDetailsMessagingExtensionCommandParameterSchema)
    .nullable()
    .optional(),
  taskInfo: z.any().nullable().optional(),
});

const IAppDetailsMessagingExtensionMessageHandlerSchema = z.object({
  type: z.string().nullable().optional(),
  value: z.object({
    domains: z.array(z.string()).nullable().optional(),
    supportsAnonymousAccess: z.boolean().nullable().optional(),
  }).nullable().optional(),
});

export const IAppDetailsMessagingExtensionsSchema = z.object({
  objectId: z.string().nullable().optional(),
  id: z.string().nullable().optional(),
  botId: z.string().nullable().optional(),
  canUpdateConfiguration: z.boolean().nullable().optional(),
  scopes: z.array(z.string()).nullable().optional(),
  authorization: z.any().nullable().optional(),
  messagingExtensionServiceType: z.string().nullable().optional(),
  apiSpecificationFilePath: z.string().nullable().optional(),
  commands: z
    .array(IAppDetailsMessagingExtensionCommandSchema)
    .nullable()
    .optional(),
  messageHandlers: z
    .array(IAppDetailsMessagingExtensionMessageHandlerSchema)
    .nullable()
    .optional(),
  requirementSet: z.string().nullable().optional(),
});